import { BookIcon, InfoIcon, LifeBuoyIcon, MessageCircleMoreIcon } from 'lucide-react';

import { Button } from '@/shared/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';
import linksConfig from '@/config/links.config';

export function HelpMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="ghost" className="rounded-full shadow-none" aria-label="Open edit menu">
          <InfoIcon size={16} aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="pb-2" align="end">
        <DropdownMenuLabel>Behöver du hjälp?</DropdownMenuLabel>
        {/* <DropdownMenuItem className="cursor-pointer py-1 focus:bg-transparent focus:underline" asChild>
          <a href="#">
            <BookIcon size={16} className="opacity-60" aria-hidden="true" />
            Documentation
          </a>
        </DropdownMenuItem> */}
        <DropdownMenuItem className="cursor-pointer py-1 focus:bg-transparent focus:underline" asChild>
          <Link to={`${linksConfig.landing}/hjalp`}>
            <LifeBuoyIcon size={16} className="opacity-60" aria-hidden="true" />
            Support
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="cursor-pointer py-1 focus:bg-transparent focus:underline" asChild>
          <a href="mailto:hej@piggo.se">
            <MessageCircleMoreIcon size={16} className="opacity-60" aria-hidden="true" />
            Kontakta oss
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
